<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header pb-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <h1 class="m-0 text-dark h4">Asignación solicitudes</h1>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right mb-0">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Tep</li>
                  <li class="breadcrumb-item active">Nacionales</li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Asignación solicitudes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card card-outline card-primary">
              <div class="card-header">
                <h3 class="card-title mb-0">Filtro</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <!-- Funcionario -->
                  <div class="form-group col-md-4 mb-0">
                    <label
                      class="col-form-label col-form-label-sm"
                      for="funcionario-solicitudes-nac"
                    >
                      Funcionario
                    </label>

                    <v-select
                      id="funcionario-solicitudes-nac"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="funcionario"
                      placeholder="Seleccione funcionario"
                      label="nombres"
                      :options="listasForms.funcionarios"
                      @input="getIndex()"
                    ></v-select>
                  </div>

                  <!-- Bloque -->
                  <div class="form-group col-md-3 mb-0">
                    <label
                      class="col-form-label col-form-label-sm"
                      for="bloque-solicitudes-nac"
                    >
                      Bloque
                    </label>

                    <v-select
                      id="bloque-solicitudes-nac"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="bloque"
                      placeholder="Seleccione bloque"
                      label="nombre"
                      :options="listasForms.bloques"
                      @input="getIndex()"
                    ></v-select>
                  </div>
                </div>
              </div>
              <div class="card-body border-top pt-3">
                <div v-drag-and-drop:options="options">
                  <ul class="list-unstyled row drag-list mb-0 mx-n2">
                    <li
                      class="drag-column col-12 col-lg-6 mb-3 px-2 d-flex"
                      v-for="group in groups"
                      :key="group.id"
                    >
                      <div
                        class="card h-100 shadow-sm border w-100 d-flex flex-column"
                      >
                        <div
                          class="drag-column-header card-header d-flex justify-content-between align-items-center py-2 bg-light border-bottom"
                        >
                          <h5 class="mb-0 h6 font-weight-bold text-dark">
                            {{ group.name }}
                          </h5>
                          <VueFeather
                            type="more-vertical"
                            class="text-muted"
                            size="18"
                          ></VueFeather>
                        </div>
                        <vue-draggable-group
                          v-model="group.items"
                          :groups="groups"
                          :data-id="group.id"
                        >
                          <ul
                            class="list-unstyled drag-inner-list mb-0 p-2 bg-light flex-grow-1 navbar-nav-scroll"
                            :data-id="group.id"
                          >
                            <li
                              class="drag-item card mb-3 border shadow-sm"
                              v-for="item in group.items"
                              :key="item.id"
                              :data-id="item.id"
                            >
                              <div class="card-body py-2 px-3 drag-item-text">
                                <dl class="row mb-0 small">
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Nº solicitud
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    {{ item.id }}
                                  </dd>
                                  <template
                                    v-if="item.users && item.users.length"
                                  >
                                    <dt class="col-5 col-sm-4 mb-1 text-muted">
                                      Usuario
                                    </dt>
                                    <dd class="col-7 col-sm-8 mb-1">
                                      {{ item.users[0].name }}
                                    </dd>
                                  </template>
                                  <template v-else>
                                    <dt class="col-12 mb-1">
                                      <span class="badge badge-danger"
                                        >Sin usuario</span
                                      >
                                    </dt>
                                  </template>
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Origen
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    <template
                                      v-if="
                                        item.sitio_origen_type ==
                                          'App\\GeocercaZona' &&
                                          item.sitio_origen != null
                                      "
                                    >
                                      {{ item.sitio_origen.nombre }}
                                    </template>
                                    <template
                                      v-else-if="
                                        item.sitio_origen_type ==
                                          'App\\Ciudad' &&
                                          item.ciudad_origen != null
                                      "
                                    >
                                      {{ item.ciudad_origen.nombre }}
                                    </template>
                                    <template v-else>
                                      {{ item.direccion_origen }}
                                    </template>
                                  </dd>
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Destino
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    <template
                                      v-if="
                                        item.sitio_destino_type ==
                                          'App\\GeocercaZona' &&
                                          item.sitio_destino != null
                                      "
                                    >
                                      {{ item.sitio_destino.nombre }}
                                    </template>
                                    <template
                                      v-else-if="
                                        item.sitio_destino_type ==
                                          'App\\Ciudad' &&
                                          item.ciudad_destino != null
                                      "
                                    >
                                      {{ item.ciudad_destino.nombre }}
                                    </template>
                                    <template v-else>
                                      {{ item.direccion_destino }}
                                    </template>
                                  </dd>
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Bloque
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    {{
                                      item.bloque
                                        ? item.bloque.nombre
                                        : "Sin asignar"
                                    }}
                                  </dd>
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Ruta
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    {{
                                      item.ruta_tep
                                        ? item.ruta_tep.nombre
                                        : "Sin asignar"
                                    }}
                                  </dd>
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Tipo vehículo
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    {{
                                      item.tipo_vehiculo
                                        ? item.tipo_vehiculo.nombre
                                        : "—"
                                    }}
                                  </dd>
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Inicio servicio
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    {{ item.fecha_hora_inicio_servicio }}
                                  </dd>
                                  <dt class="col-5 col-sm-4 mb-1 text-muted">
                                    Fin servicio
                                  </dt>
                                  <dd class="col-7 col-sm-8 mb-1">
                                    {{ item.fecha_hora_fin_servicio }}
                                  </dd>
                                </dl>
                                <div class="mt-2 pt-2 border-top">
                                  <template
                                    v-if="
                                      item.pasajeros &&
                                        item.pasajeros.length > 0
                                    "
                                  >
                                    <div
                                      class="alert alert-light border mb-0 py-2 small"
                                    >
                                      <strong class="d-block mb-1"
                                        >Pasajeros</strong
                                      >
                                      <ul class="list-unstyled mb-0 pl-0">
                                        <li
                                          v-for="pasajero in item.pasajeros"
                                          :key="pasajero.id"
                                        >
                                          {{ pasajero.nombres }}
                                          {{ pasajero.apellidos }}
                                        </li>
                                      </ul>
                                    </div>
                                  </template>
                                  <span v-else class="badge badge-danger"
                                    >Sin pasajeros</span
                                  >
                                </div>
                                <div class="mt-2 pt-2 border-top">
                                  <template
                                    v-if="
                                      item.ceco_afe && item.ceco_afe.length > 0
                                    "
                                  >
                                    <div
                                      class="alert alert-light border mb-0 py-2 small"
                                    >
                                      <strong class="d-block mb-1"
                                        >Orden Interna / PEP</strong
                                      >
                                      <ul class="list-unstyled mb-0 pl-0">
                                        <li
                                          v-for="ceco in item.ceco_afe"
                                          :key="ceco.id"
                                        >
                                          {{ ceco.nTipoPresupuesto }} -
                                          {{ ceco.numero }}
                                        </li>
                                      </ul>
                                    </div>
                                  </template>
                                  <span v-else class="badge badge-danger"
                                    >Sin orden interna / PEP</span
                                  >
                                </div>
                                <div class="mt-2 pt-2 border-top">
                                  <template v-if="item.motivo">
                                    <div
                                      class="alert alert-light border mb-0 py-2 small"
                                    >
                                      <strong class="d-block mb-1"
                                        >Motivo de la solicitud</strong
                                      >
                                      <ul class="list-unstyled mb-0 pl-0">
                                        <li>
                                          {{ item.motivo }}
                                        </li>
                                      </ul>
                                    </div>
                                  </template>
                                  <span v-else class="badge badge-danger"
                                    >Sin motivo de la solicitud</span
                                  >
                                </div>
                                <div
                                  class="mt-2 pt-2 border-top text-right"
                                  v-if="group.id == 1 && $store.getters.can('tep.solicitudesNacionalesComb.cancel')"
                                >
                                  <button
                                    type="button"
                                    class="btn btn-outline-danger btn-sm"
                                    data-toggle="modal"
                                    data-target="#modal-form-cancelar-solicitud-nacional"
                                    @click="abrirCancelar(item)"
                                  >
                                    <i class="fas fa-ban mr-1"></i>
                                    Cancelar Solicitud
                                  </button>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </vue-draggable-group>
                        <div
                          class="card-footer bg-transparent border-top py-2 text-right mt-auto"
                          v-if="group.id == 2 && group.items.length > 0"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            @click="edit(group.items)"
                          >
                            <i class="fas fa-check-circle mr-1"></i>
                            Validar solicitud
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <SolicitudesNacionalesCancelar ref="SolicitudesNacionalesCancelar" />
  </div>
</template>
<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";
import VueFeather from "vue-feather";
import SolicitudesNacionalesCancelar from "./SolicitudesNacionalesCancelar";

export default {
  name: "SolicitudesNacionalesIndex",
  components: {
    vSelect,
    Loading,
    VueFeather,
    SolicitudesNacionalesCancelar,
  },
  data() {
    return {
      cargando: false,
      filtros: {},
      origen: [],
      destino: [],
      funcionario: null,
      bloque: null,
      solicitudes: {},
      arrayAntGroup: [],
      listasForms: {
        ciudades: [],
        sitios: [],
        sitio_types: [],
        funcionarios: [],
        bloques: [],
      },
      groups: [
        {
          id: 1,
          name: "Solicitudes pendientes",
          items: [],
        },
        {
          id: 2,
          name: "Solicitud final",
          items: [],
        },
      ],
      options: {
        dropzoneSelector: ".drag-inner-list",
        draggableSelector: ".drag-item",
      },
    };
  },

  methods: {
    getIndex() {
      this.cargando = true;
      // Se ajusta los parámetros del filtro
      this.filtros.user_id = null;
      if (this.funcionario) {
        this.filtros.user_id = this.funcionario.user_id;
      }

      this.filtros.bloque_id = null;
      if (this.bloque) {
        this.filtros.bloque_id = this.bloque.id;
      }

      this.filtros.origen_id = null;
      if (this.filtros.sitio_origen_type && this.origen) {
        this.filtros.origen_id = this.origen.id;
      }

      this.filtros.destino_id = null;
      if (this.filtros.sitio_destino_type && this.destino) {
        this.filtros.destino_id = this.destino.id;
      }

      axios
        .get("/api/tep/solicitudesNacionales", {
          params: this.filtros,
        })
        .then((response) => {
          this.cargando = false;
          this.groups[0].items = response.data;
          this.groups[1].items = [];
        });
    },

    async init() {
      await this.groups[0].items.unshift(this.arrayAntGroup[0]);
      this.arrayAntGroup = [];
    },

    /*  async change(evt) {
      let pasajeros = 0;
      for (let i = 0; i < evt[1].items.length; i++) {
        pasajeros += evt[1].items[i].pasajeros.length;
        if (i > 0) {
          if (
            evt[1].items[i - 1].tipo_vehiculo_id !=
            evt[1].items[i].tipo_vehiculo_id
          ) {
            await this.$swal({
              title: "El tipo de vehículo no es el mismo !!!.",
              text: "Que tipo de vehiculos esta agregando en esta solicitud?",
              icon: "warning",
              showCancelButton: true,
              position: "top-end",
              toast: true,
              padding: "2em",
              background: "#fff url(/img/boxed-bg.png)",
              backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
              confirmButtonText: evt[1].items[i].tipo_vehiculo.nombre,
              cancelButtonText: evt[1].items[i - 1].tipo_vehiculo.nombre,
            }).then((result) => {
              if (result.value) {
                this.arrayAntGroup.push(this.groups[1].items[i - 1]);
                this.groups[1].items.splice(i - 1, 1);
              } else {
                this.arrayAntGroup.push(this.groups[1].items[i]);
                this.groups[1].items.splice(i, 1);
              }
            });
          } else if (
            pasajeros > evt[1].items[i].tipo_vehiculo.cantidad_pasajeros
          ) {
            await this.$swal({
              title: "Excedio la cantidad de pasajeros permitida",
              text:
                "La cantidad máxima de pasajeros para el tipo de vehiculo " +
                " " +
                evt[1].items[i].tipo_vehiculo.nombre +
                " " +
                "son" +
                " " +
                " " +
                evt[1].items[i].tipo_vehiculo.cantidad_pasajeros,
              icon: "warning",
              showConfirmButton: false,
              timer: 2000,
              backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
            });
            this.arrayAntGroup.push(this.groups[1].items[i]);
            this.groups[1].items.splice(i, 1);
          }
        }
      }

      if (this.arrayAntGroup.length > 0) {
        await this.init();
      }
    },
 */
    edit(solicitudes) {
      return this.$router.push({
        name: "/Tep/SolicitudesNacionalesForm",
        params: {
          data_edit: solicitudes,
          id: solicitudes.id,
        },
      });
    },

    abrirCancelar(item) {
      this.$refs.SolicitudesNacionalesCancelar.llenar_modal(item);
    },

    buscarSitios() {
      let me = this;
      var url = "api/admin/basico/geocercaZona/lista";
      axios
        .get(url, {
          params: {
            estado: 1,
          },
        })
        .then(function(response) {
          let respuesta = response.data;
          me.listasForms.sitios = respuesta;
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    buscarCiudades() {
      let me = this;
      var url = "api/admin/ciudades/lista";
      axios
        .get(url)
        .then(function(response) {
          let respuesta = response.data;
          me.listasForms.ciudades = respuesta;
        })
        .catch(function(error) {
          me.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getSitioType() {
      axios.get("/api/lista/94").then((response) => {
        this.listasForms.sitio_types = response.data;
      });
    },

    getBloques() {
      axios.get("/api/tep/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    getFuncionarios() {
      let me = this;
      var url = "api/admin/funcionarios/lista";
      axios
        .get(url, {
          params: {
            gerente_area: 1,
          },
        })
        .then(function(response) {
          me.listasForms.funcionarios = response.data;
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    clearOrigen() {
      this.origen = null;
      this.getIndex();
    },

    clearDestino() {
      this.destino = null;
      this.getIndex();
    },
  },
  mounted() {
    this.getIndex();
    this.buscarSitios();
    this.buscarCiudades();
    this.getSitioType();
    this.getFuncionarios();
    this.getBloques();
  },
};
</script>
